import { useState, useEffect, Fragment } from 'react';
import { ICourse, InputFieldConfig, IRegionConfig } from 'types';
import { Q } from '../../../types';
import { CourseEvidenceVisible as Visible, CourseEvidenceMandatory as Mandatory } from '../../../utilities/types';
import { TextareaWithConfirm } from '../../formInputs/Textarea';
import { ContinueButton } from '../../atoms/ContinueButton';

interface IProps {
  index: number;
  courseNames?: Array<string>;
  offerEvidence?: string;
  config: IRegionConfig;
  visible: Visible;
  mandatory: Mandatory;
  onSaveAndClose: (course: Partial<ICourse>) => void;
}

export const EvidenceOfOffer = (props: IProps) => {
  const { index, visible, mandatory, onSaveAndClose } = props;

  const [offerEvidence, setOfferEvidence] = useState(props.offerEvidence);

  const [complete, setComplete] = useState(!visible.offerEvidence || !mandatory.offerEvidence || offerEvidence !== '');

  const {
    OfferEvidence: offerEvidenceConfig
  }: {
    OfferEvidence: InputFieldConfig;
  } = props.config.Checklist.PersonalInfo.Page5_1;

  const saveAndClose = () => {
    onSaveAndClose({
      offerEvidence
    });
  };

  const handleOnSaveAndCloseClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    saveAndClose();
  };

  useEffect(() => {
    setComplete(!visible.offerEvidence || !mandatory.offerEvidence || offerEvidence !== '');
  }, [offerEvidence, mandatory, visible]);

  return (
    <>
      {visible.offerEvidence && (
        <TextareaWithConfirm
          key={Q.COURSE_OFFER_EVIDENCE}
          id={Q.COURSE_OFFER_EVIDENCE}
          value={offerEvidence}
          label={(props.courseNames ?? []).map((x: string, i: number) => (
            <Fragment key={`label-${i}`}>
              {x}
              <br />
            </Fragment>
          ))}
          subText={offerEvidenceConfig.subLabel}
          inputHelperText={''}
          onChange={(evt: React.FormEvent<HTMLTextAreaElement>) => setOfferEvidence(evt.currentTarget.value)}
        />
      )}

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};
